import styled from 'styled-components';

export const StyledFareSection = styled.section`
    width: 100%;
    height: 1042px;
    text-align: center;

    & h2 {
        margin: 50px 0 30px 0;
    }

    & > div {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: flex-start;
    }

    @media screen and (min-width: 577px) {
        max-width: 1340px;
        height: 771px;

        & h2 {
            margin: 0 0 50px 0;
        }

        & > div {
            display: flex;
            flex-direction: row;
            justify-content: center;
        }
    }
`;

export const StyledFareSectionWrapper = styled.div`
    display: flex;
    justify-content: center;
    width: 100%;
    margin: 0 0 50px 0;
    background: linear-gradient(180deg, #ffffff 3.14%, #00a0b6 100%);

    @media screen and (min-width: 577px) {
        margin: 0 0 80px 0;
    }
`;

export const StyledFareCard = styled.article`
    box-sizing: border-box;
    width: 330px;
    height: 430px;
    display: flex;
    flex-direction: column;
    margin: 0 0 20px 0;
    padding: 20px 15px 15px 15px;
    align-items: stretch;
    background-color: #ffffff;
    border: none;
    border-radius: 20px;
    background-repeat: no-repeat;
    background-position: 50% 60%;
    background-size: contain;

    & a {
        width: auto;
        margin-top: auto;
    }

    & p {
        margin-top: 10px;
        padding: 0 20px;
        font-weight: 500;
        font-size: 16px;
        line-height: 20.4px;
    }

    @media screen and (min-width: 577px) {
        width: 445px;
        height: 580px;
        margin: 0 15px;
        padding: 30px 28px;
        border-radius: 30px;

        & p {
            margin-top: 15px;
            font-weight: 500;
            font-size: 20px;
            line-height: 25.5px;
            padding: 0 30px;
        }
    }

    ${({ $specificCss }) => $specificCss ?? ''};
`;

export const StyledFareCardBackground = styled.div``;
